import {
	LocalizedDimensionDO,
	LocalizedVerticalDO,
} from "@/modules/explorer/components/AxisConfiguration/Selection.vue";

export interface ActivePin {
	dimension: App.Data.DimensionDO;
	isApplied: boolean;
	valuesAreIncluded: boolean;
	// Where this pin came from — a dimension the user favorited themselves, one favorited via
	// one of their roles, or undefined when pinned through some other flow (e.g. manually from
	// a filter chip) where source doesn't apply/is implicitly the user.
	source?: App.Enums.FavoriteDimensionSource;
}

// Adapter between the backend's favorite-dimensions response shape and this app's internal
// ActivePin model. Centralizing the unwrap here (rather than at every call site) means a future
// backend response shape change (e.g. adding another nesting level) only needs updating here.
export function toActivePinFromFavoriteDimension(
	favorite: App.Data.FavoriteDimensionDO
): ActivePin {
	return {
		dimension: favorite.dimension,
		isApplied: true,
		valuesAreIncluded: true,
		source: favorite.source,
	};
}

export interface ExplorerState {
	selectedFilter: App.Data.Explorer.Filter.ActiveFilterDTO | null;
	activePins: ActivePin[] | [];
	showMeasureDateTime: boolean;
	showDataFullScreen: boolean;
	lastUpdated: Date;
	lastUpdatedInBackground: Date;
	documentFetchedFromHistory: boolean;
	isDocumentLoaded: boolean;
	addDocumentToHistory: Function | null;
	getPreviousDocument: Function | null;
	getNextDocument: Function | null;
	isShiftPressed: boolean;
	lastClickhouseQueryPerformance: object;
	lastClickhouseSql: string;
	lastClickhouseBaseDataSql: string;
	isGraphUpdatingInBackground: boolean;
	showDateComparisonBar: boolean;
	selectedComparisonYears: number[];
	lastUsedMeasureDateTime: Date;
	areHotkeysEnabled: boolean;
	activeDataView: App.Enums.DocumentViewTabs;
	savedDocumentID: number | null;
	documentAlert: App.Data.Alerts.DocumentAlertDO | null;
	redirectToAlertsAfterSave: boolean;
}

export interface ExplorerStore {
	document: App.Data.Explorer.DocumentDO | null;
	derivedDocument: App.Data.Explorer.DocumentDO | null;
	explorerState: ExplorerState;
}

export interface PropertyStore {
	verticals: LocalizedVerticalDO[];
	dimensions: LocalizedDimensionDO[];
}

type UnderlyingInternals = {
	identifier: string;
	timestamp: number;
};

export type DataStreamStatus = {
	store_table_name: string;
	cycle_timestamp_preparation: string;
	underlying_internals: UnderlyingInternals[];
};
